import { render, staticRenderFns } from "./ArticleTeaser.vue?vue&type=template&id=0813da78&"
import script from "./ArticleTeaser.js?vue&type=script&lang=js&"
export * from "./ArticleTeaser.js?vue&type=script&lang=js&"
import style0 from "./ArticleTeaser.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports